import { BarChart10, Package, Target04 } from "@untitledui/icons";
import type { FC, SVGProps } from "react";

export type HeroSuggestion = {
  icon: FC<SVGProps<SVGSVGElement>>;
  question: string;
};

export const HERO_SUGGESTIONS: HeroSuggestion[] = [
  { icon: BarChart10, question: "Which creators drove the most GMV in the last 30 days?" },
  { icon: Package, question: "Who received samples but hasn't posted yet?" },
  { icon: Target04, question: "What should I look at first today?" },
];
